import React, {useState} from 'react';
import {helpSubNodesString} from '../HelpStrings'

export default function HelpSubNodes(props){

      const [expand, setExpand] = useState(true)

      return (<span>
        {helpSubNodesString}
        <button type="button" aria-label={expand?"Expand":"Collapse"} class={expand?"rstcustom__expandButton":"rstcustom__collapseButton"} style={{position:"relative", display:"block", fontSize:"30px"}}
          onClick={()=>setExpand(!expand)}>
        </button>
      </span>);
}
